import * as React from 'react'

import { Input, Label, Button, FormGroup, CustomInput } from 'reactstrap'

import TerminationFormData from '../TerminationFormData.interface'
import TerminationFormDataUpdate from '../TerminationFormDataUpdate.type'

import TerminationReasonSelect from './TerminationReasonSelect.component'

export interface TerminationReasonProps {
  terminationForm: TerminationFormData
  statusCallback: TerminationFormDataUpdate
}

export interface TerminationReasonState {
  reason?: string
  comments?: string
  eligibleForRehire?: boolean
}

class TerminationReason extends React.PureComponent<TerminationReasonProps, TerminationReasonState> {
  constructor(props) {
    super(props)

    const eligibleForRehire = props.terminationForm.eligibleForRehire === undefined ? true : props.terminationForm.eligibleForRehire
    this.state = {
      eligibleForRehire,
      reason: props.terminationForm.reason,
      comments: props.terminationForm.comments
    }
    
    this.updateDateStatus = this.updateDateStatus.bind(this)
  }

  updateDateStatus() {
    const { terminationForm } = this.props
    const { reason, comments, eligibleForRehire } = this.state

    terminationForm.reason = reason
    terminationForm.comments = comments
    terminationForm.eligibleForRehire = eligibleForRehire
    this.props.statusCallback('FINAL_CONFIRMATION', terminationForm)
  }

  render() {
    const { reason, comments, eligibleForRehire } = this.state
    
    return (
      <div className="w-100 p4">
        <div>
          <h5 className="text-justify">Select termination reason.</h5>
          <TerminationReasonSelect value={reason} onChange={(value: string) => this.setState({ reason: value })} />
        </div>

        <div className="mt-3">
          <span style={{ fontSize: '13px' }}>Comments</span>
          <Input
            type="textarea"
            value={comments}
            className="mt-1"
            onChange={e => this.setState({ comments: e.target.value })}
          />
        </div>

        <FormGroup check className="mt-3">
          <Label check>
            <Input
              type="checkbox"
              checked={eligibleForRehire}
              onChange={e => this.setState({ eligibleForRehire: e.target.checked })}
            />
            {' '}
            <h6 className="mb-0">
              Eligible for rehire
            </h6>
          </Label>
        </FormGroup>

        {!!reason && (
          <Button color="primary" className="btn-block mt-4" onClick={this.updateDateStatus}>
            Complete Termination
          </Button>
        )}
      </div>
    )
  }
}

export default TerminationReason


// WEBPACK FOOTER //
// ./src/routes/terminations/termination-flow/components/TerminationReason.component.tsx